<template>
  <div>
      <slot></slot>
      <div style="display:flex" v-if="focus && focus.state == 'ontrack'">
            <div>
                <div style="display:flex">
                    <textarea style="flex:1" placeholder="put youtube url here..." v-model="inputYtbUrl" />
                    <button @click="handleAddVideo" style="height: fit-content">Add</button>
                </div>
                <div v-if="tool.plan && tool.plan.videos && tool.plan.videos.length">
                    <div style="display:flex;border: 1px solid #e8e8e9" v-for="(video,index) in tool.plan.videos.filter(el => !el._deleted_at)" :key="index" class="my-3 p-1 align-items-center">
                        <img :title="video.video_url" :src="video.img_url" :height="150" :width="150" class="mr-4" />
                        <!-- <span style="max-width: 75%" class="mr-2">{{video.video_url}}</span> -->
                        <button v-b-modal="tool && tool.text" @click="handleLaunch(video)" style="height: fit-content">Watch</button>
                    </div>
                </div>
            </div>
        </div>

      <div style="display:flex" v-else-if="focus && focus.state == 'ondeck'">
          <div>
            <div style="display:flex">
              <textarea style="flex:1" placeholder="put youtube url here..." v-model="inputYtbUrl" />
              <button @click="handleAddVideo" style="height: fit-content">Add</button>
            </div>
            <div v-if="tool.plan && tool.plan.videos && tool.plan.videos.length">
              <div style="display:flex; border: 1px solid #e8e8e9" v-for="(video,index) in tool.plan.videos.filter(el => !el._deleted_at)" :key="index" class="my-3 p-1" >
                  <!-- <span v-if="isEditingVideo !== index" style="max-width: 75%" class="mr-2">{{video.video_url}}</span> -->
                  <img v-if="isEditingVideo !== index" :title="video.video_url" :src="video.img_url" :height="150" :width="150" class="mr-4" />
                  <input v-else style="max-width: 75%" class="mr-2" v-model="editVideoInput" />
                  <span style="flex: 1; display: flex; justify-content: flex-end; align-items: center">
                    <button v-if="isEditingVideo !== index" style="height: fit-content" @click="handleEditVideo(index, video)">Edit</button>
                    <button v-else style="height: fit-content" @click="handleConfirmEditVideo(index, video)">Save</button>
                    <button style="height: fit-content" @click="handleRemoveVideo(index, video)">Remove</button>
                  </span>
              </div>
          </div>
      </div>
      </div>

       <div v-if="focus && focus.state == 'stationed'">
        <!-- <div style="display:flex">
          <canvas :id="tool && tool.text"></canvas>
        </div> -->
        <div v-if="tool.plan && tool.plan.videos && tool.plan.videos.length">
          <div style="display:flex; border: 1px solid #e8e8e9" v-for="(video,index) in tool.plan.videos.filter(el => !el._deleted_at)" :key="index" class="my-3 p-1" >
              <img :title="video.video_url" :src="video.img_url" :height="150" :width="150" class="mr-4" />
          </div>
        </div>
      </div>

      <div
        v-show="videoEmbedUrl"
        :id="tool && tool.text"
        class="modal-video"
        @focusout="(e) => {
          e.stopPropagation()
          videoEmbedUrl = null
        }"
        tabindex="0"
      >
        <!-- @click="(e) => {
          e.stopPropagation()
          videoEmbedUrl = null
        }" -->
        <!-- :style="videoEmbedUrl ? 'display: block': 'display: none'" -->
        <div style="height: 40%;" @click="() => {}">
          <iframe width="100%" height="100%"
            :src="videoEmbedUrl">
          </iframe>
          <textarea rows="6" placeholder="Your notes here.." v-model="noteVideo" class="notepad ml-4" />
        </div>
      </div>
  </div>
</template>
<script>

export default {
  name: 'tool-youtubeviewer',
  components: {

  },
  props: {
    tool: {
      type: Object,
      required: false,
      default:()=>{}
    },
    focus: {
      type: Object,
      required: false,
      default:()=>{}
    },
    user: {
      type: String,
      default: () => ""
    },
    setTracker: {
      type: Function,
      default: () => () => {}
    },
    addPlan: {
      type: Function,
      default: () => () => {}
    },
    setPlan: {
      type: Function,
      default: () => () => {}
    },
    removePlan: {
      type: Function,
      default: () => () => {}
    }
  },
  watch: {
    videoEmbedUrl(n,o) {
      if(!n && o) {
        this.handleHideVideoModal()
      } else if(n && !o) {
        this.handleShowVideoModal()
      }
    }
  },
  methods:{
    handleShowVideoModal() {
      this.trackVideo = {_started_at: new Date(), video_url: this.videoEmbedUrl}
    },
    handleHideVideoModal() {
      this.trackVideo = {...this.trackVideo, _ended_at: new Date(), text: this.noteVideo}
      // this.$store.dispatch('tools/addTrackIntoYtbTool', {track: this.trackVideo, focusId: this.focus.focusId, tools_id: this.tool.tools_id})
      this.setTracker({track: this.trackVideo, focusId: this.focus.focusId, tools_id: this.tool.tools_id})
      this.videoEmbedUrl = null
    },
    getEmbedUrl(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);

      let videoId = (match && match[2].length === 11)
        ? match[2]
        : null;
      return {url: `https://www.youtube.com/embed/${videoId}`, img: `https://img.youtube.com/vi/${videoId}/0.jpg`}
    },
    handleAddVideo(){
      let embedURL = this.getEmbedUrl(this.inputYtbUrl).url
      let embedCaptImg = this.getEmbedUrl(this.inputYtbUrl).img
      let videoToSave = {
        _created_at: new Date(),
        _created_by: this.user,
        video_url: embedURL,
        img_url: embedCaptImg
      }
      // this.$store.dispatch('tools/addVideoIntoYtbTool', {video: videoToSave, focusId: this.focus.focusId, tools_id: this.tool.tools_id})    
      this.addPlan({video: videoToSave, focusId: this.focus.focusId, tools_id: this.tool.tools_id})    
    },
    handleEditVideo(index,video) {
      this.isEditingVideo = index
      this.editVideoInput = video.video_url
    },
    handleConfirmEditVideo(index,video) {
      // this.$store.dispatch('tools/editVideoUrlInYtbTool', {video_url: this.editVideoInput, indexVideo:index, focusId: this.focus.focusId, tools_id: this.tool.tools_id})    
      this.setPlan({video_url: this.editVideoInput, indexVideo:index, focusId: this.focus.focusId, tools_id: this.tool.tools_id})    
      // .then(() => {
      //   })
        this.isEditingVideo = ""
        this.editVideoInput = ""
    },
    handleRemoveVideo(index,video) {
      // this.$store.dispatch('tools/removeVideoInYtbTool', {indexVideo: index, focusId: this.focus.focusId, tools_id: this.tool.tools_id})    
      this.removePlan({indexVideo: index, focusId: this.focus.focusId, tools_id: this.tool.tools_id})    

    },
    handleLaunch(video){
      this.video = video
      this.videoEmbedUrl = video.video_url
    },
  },
  computed: {
  },
  data: function() {
    return {
      result: 0,
      showTracking: false,
      tmp_value: 0,
      reset: false,
      operator: undefined,
      tooltype: 'calculator',
      options: {
        fullWidth: !0,
        chartPadding: {
          right: 15,
          left: -15,
        },
        low: 0,
        showArea: true
      },
      //state for add / edit video
      inputYtbUrl: "",
      isEditingVideo: "",
      editVideoInput: "",
      
      //state for watch
      videoEmbedUrl: null,
      trackVideo: null,
      noteVideo: ""
    }
  },
  mounted(){
  }
}
</script>
<style lang="scss" scoped>
  .calculator {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 3rem;

    table {
      color: #fff;
    }

    input {
      display: block;
      width: calc(100% - 40px);
      height: 75px;
      padding: 5px 20px 0;
      margin-bottom: 10px;
      border: none;
      background-color: #222;
      color: #fff;
      font-size: 4rem;
      text-align: right;
    }

    .button {
      margin: 10px;
      width: 80px;
      height: 80px;
      text-align: center;
      font-weight: bold;
      cursor: pointer;
      border: #6a7a84;
    }

    .button-col2 {
      width: 160px;
      height: 80px;
      text-align: center;
      font-weight: bold;
      cursor: pointer;
    }

    .grey {
      background-color: #ccc;
      color: #333;

      &:hover {
        background-color: #ddd;
      }
    }

    .dark {
      background-color: #444;
      color: #fff;

      &:hover {
        background-color: #555;
      }
    }

    .orange {
      background-color: #e08d1f;
      color: #fff;

      &:hover {
        background-color: #fda22b;
      }
    }
  }
  .notepad {
    background-color: rgb(255, 242, 204);
    border-radius: 10px;
    width: 100%;
  }
  .card-body {
    overflow-y: auto;
  }
  .modal-video {
    background-color: rgba(0,0,0,0.5);
    width: auto;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2000;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>